<template>
  <div class="troubadour">
    <VideoBanner :v-if='$route.name === "Troubadour"'  posterSrc='trubadur.jpg' mp4Src='trubadur.mp4' webmSrc='trubadur.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Trubadur</h2>
        <div class="troubadur-content page-content">
          <b-row>
            <b-col>
              <h3>Stämningshöjare för alla typer av event</h3>
              <p>En trubadur skapar närvaro och känsla oavsett om det handlar om lugn bakgrundsmusik, allsång vid middagsbordet eller fullt ös framåt småtimmarna. Vi samarbetar med rutinerade trubadurer som anpassar sig efter just er tillställning.</p>
              <h3>Flexibel underhållning - från visor till party</h3>
              <p>Vill ni ha mingelmusik till välkomstdrinken, visor till middagen, en fartfylld afterski-stämning eller kanske en musikquiz med gästerna? Inga problem. Vi erbjuder trubadurer som täcker allt från klassiska visor och svenska hits till temakvällar och pubstämning.</p>
              <h3>Vi skräddarsyr efter era behov</h3>
              <p>Berätta vad ni planerar, bröllop, firmafest, födelsedag, sommarfest eller något annat så matchar vi med rätt trubadur. Vi hjälper er skapa rätt känsla och en minnesvärd kväll.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
